<template>
  <div id="app" :class="[TemplateType?'TempS'+TemplateType:'']">
    <!-- <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive> -->
    <router-view :key="$route.fullPath"></router-view>
    <loading v-if="this.$store.state.isLoad"></loading>
  </div>
</template>

<script>
  import store from 'vuex'
  import loading from './components/loading.vue'
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isAlive: true,
        address: ''
      }
    },
    components: {
      loading
    },
    created() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if(!isMobile){
        window.location.href = this.pcUrl;
      }
    },
    methods: {
      reload() {
        this.isAlive = false;
        this.$nextTick(function () {
          this.isAlive = true
        })
      },
      async checkwallet(){
        if (!window.ethereum && !window.trustwallet.ethereum) {
          // this.needWallet = true;
          // window.location.href = 'https://link.trustwallet.com';
        }else{
          this.getAddress();
        }
      },


      async getAddress() {
          var that = this;
          let web3Provider = null;
          if (window.ethereum) {
            web3Provider = window.ethereum;
            try {
              await window.ethereum.request({ method: "eth_requestAccounts" });
            } catch (error) {
              console.error("User denied account access");
              return false;
            }
          } else if (window.web3) {
            web3Provider = window.web3.currentProvider;
          } else {
            web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
          }
          if (web3Provider) {
            const Web3address = new Web3(web3Provider);
            try {
              const accounts = await Web3address.eth.getAccounts();
              const address = accounts[0];
              if (address) {
                that.address = address;
                that.getEthLogin();
              } else {
                that.$toast.center('Failed to connect to address');
              }
            } catch (error) {
              that.$toast.center('Failed to connect to address');
            }
          } else {
            that.$toast.center('Failed to connect to address');
          }
      },
      getEthLogin(){
        let params = {
            address: this.address,
            // address: '0xCA62b5Cb65D4dad8AeEea158cB72a4257Fc25E24'
        }
        this.$ajax.get('/web/ethLogin',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            localStorage.setItem('account',resData.name);
            localStorage.setItem('token',resData.token);
            localStorage.setItem('uid',resData.data.id);
            localStorage.setItem('agentId',resData.data.agent_id);
            this.$router.push('/index');
          }else{
            this.$toast.center(res.data.message);
          }
        }).catch(function(err){
            console.log(err)
        })
      },

    },

  }

</script>
<style type="text/css" lang="less">
input::placeholder{font-size: 0.5rem;}
.temp1Inputb{margin: 0.2rem 0.1rem 0.6rem;display: flex;justify-content: space-between;align-items: center;
  position: relative;
  .text1{width: calc(100% - 0.8rem);padding: 0.4rem;border: 1px solid #ddd;border-radius: 6px;
    display: inline-block;font-size: 0.4rem;}
  .text1:focus{border: 1px solid #000000;}
  .text2{position: absolute;right: 0.3rem;color: #666;font-size: 0.4rem;}
}
.TempS1{
  @main_color: #4458ed;
  .temp1color.active{color: @main_color !important;font-size: 0.5rem !important;}
  .temp1border{border: 1px solid @main_color !important;}
  .temp1border2{border: 1px solid #ddd !important;}
  .temp1border2:focus{border: 1px solid @main_color !important;}
  .temp1color::after{background-color: @main_color !important;}
  .temp2color{color: @main_color !important;}
  .blueBottomLine{background-color: @main_color !important;width: 1rem;height: 2px;display: inline-block;
    position: relative;top: -0.45rem;
  }
  .buttbg{background-color: @main_color !important;}
  .btn-login.active{background: @main_color !important;}
  .butt_W_BB{color: #333 !important;border: 1px solid #333;background-color: #fff !important;}
  .linearBg{background-image: linear-gradient(90deg, #468bd9, #9fc5ef) !important;}
  .temp1Inputb{
    .text1:focus{border: 1px solid @main_color;}
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue